import React, { Component } from "react";
import { Divider, Row, Layout, Popover, Icon, Descriptions } from "antd";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import axios from "axios";
// import HorizontalAdComponent from "../ads/HorizontalAdComponent";
// import HorizontalAdPopup from "../ads/HorizontalAdPopup";
// import NWAdPopup from "../ads/NWAdPopup.js";
import StageEnemiesTable from "../table/StageEnemiesTable";
import StageEnemiesCollapse from "../table/StageEnemiesCollapse";
import StageDropsTable from "../table/StageDropsTable";

const { Content } = Layout;
// const samplestage = {
//   sampledata: {
//     name: "Utopia is over there",
//     level: "Silk Road",
//     base_hp: 750000,
//     energy: 90,
//     xp: 1710,
//     max_enemy: 8,
//     length: 5500,
//     drops: [
//       {
//         name: "Treasure Chest",
//         img: 999999,
//         drop_chance: "1%",
//         drop_count: 1,
//       },
//     ],
//     difficulties: [
//       {
//         difficulty: "1 Star",
//         stage_amp: 100,
//       },
//       {
//         difficulty: "2 Stars",
//         stage_amp: 140,
//       },
//       {
//         difficulty: "3 Stars",
//         stage_amp: 160,
//       },
//       {
//         difficulty: "4 Stars",
//         stage_amp: 140,
//       },
//     ],
//     enemies: [
//       {
//         enemy_no: "003",
//         enemy_name_en: "Hippoe",
//         amplifier: 400,
//         number: 0,
//         base_trigger: 100,
//         time_trigger: 40,
//         spawn_interval: "60~500",
//         is_boss: "No",
//       },
//       {
//         enemy_no: "047",
//         enemy_name_en: "Metal Hippoe",
//         amplifier: 400,
//         number: 3,
//         base_trigger: 100,
//         time_trigger: 200,
//         spawn_interval: "60~120",
//         is_boss: "No",
//       },
//       {
//         enemy_no: "047",
//         enemy_name_en: "Metal Hippoe",
//         amplifier: 400,
//         number: 0,
//         base_trigger: 99,
//         time_trigger: 0,
//         spawn_interval: "1000~1200",
//         is_boss: "No",
//       },
//       {
//         enemy_no: "113",
//         enemy_name_en: "Heavenly Hippoe",
//         amplifier: 100,
//         number: 0,
//         base_trigger: 100,
//         time_trigger: 700,
//         spawn_interval: "180~500",
//         is_boss: "No",
//       },
//       {
//         enemy_no: "113",
//         enemy_name_en: "Heavenly Hippoe",
//         amplifier: 100,
//         number: 0,
//         base_trigger: 100,
//         time_trigger: 720,
//         spawn_interval: "600~1000",
//         is_boss: "No",
//       },
//       {
//         enemy_no: "054",
//         enemy_name_en: "Super Metal Hippoe",
//         amplifier: 100,
//         number: 3,
//         base_trigger: 99,
//         time_trigger: 1200,
//         spawn_interval: "600~800",
//         is_boss: "No",
//       },
//       {
//         enemy_no: "059",
//         enemy_name_en: "Sir Metal Seal",
//         amplifier: 99,
//         number: 1,
//         base_trigger: 100,
//         time_trigger: 1200,
//         spawn_interval: "320~720",
//         is_boss: "Yes",
//       },
//       {
//         enemy_no: "021",
//         enemy_name_en: "Ms. Sign",
//         amplifier: 2000,
//         number: 0,
//         base_trigger: 100,
//         time_trigger: 27000,
//         spawn_interval: "27000",
//         is_boss: "No",
//       },
//     ],
//   },
// };

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com:5000/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
  
};

class SingleStage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      viewportHeight: 0,
      selectedStage: [],
    };
  }

  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title =
      this.props.match.params.stagename +
      " | Stage Info | Battle Cats Wiki for Cat Stats";

    const { stageid } = this.props.match.params;

    axios
      .post("https://onestoppress.com/api/singlestage", {
        stagenum: stageid,
      })
      .then((res) => {
        let stageone = res.data.sampledata;
        if (res.data.hasOwnProperty("sampledata")) {
          this.setState({
            selectedStage: stageone,
          });
        }
      });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }
    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  render() {
    // const name = this.state.selectedStage.name;
    // const chapter = this.state.selectedStage.chapter;
    // const stagetitle = chapter + " > " + name;
    // const base_hp = this.state.selectedStage.base_hp;
    // const energy = this.state.selectedStage.energy;
    // const xp = this.state.selectedStage.xp;
    // const max_enemy = this.state.selectedStage.max_enemy;
    // const length = this.state.selectedStage.length;
    // const drops = this.state.selectedStage.drops;
    // const difficulties = this.state.selectedStage.difficulties;
    // const enemies = this.state.selectedStage.enemies;

    let {
      name,
      chapter,
      base_hp,
      energy,
      xp,
      max_enemy,
      length,
      drops,
      difficulties,
      enemies,
    } = this.state.selectedStage;
    let stagetitle = chapter + " > " + name;

    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              maxWidth: this.state.viewportWidth - 104,
              float: "left",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
            }}
          >
            Stage Info
          </h1>
          <div style={{ paddingTop: "10px" }}>
            <Popover
              content={
                <div>Credit to r/battlecats Discord channel for the data</div>
              }
              placement="bottomRight"
            >
              <Icon type="info-circle" />
            </Popover>
          </div>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width-max">
            <div
            >
              {/* <HorizontalAdComponent
                // viewportWidth={this.state.viewportWidth}
                dataAdClient="ca-pub-1920730948516638"
                dataAdSlot="6964595840"
                // style={{ padding: "16px 0 0px 0" }}
              /> */}
              <Row style={{ padding: "16px 0 0px 0" }}>
                <Descriptions
                  title={stagetitle}
                  bordered
                  column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}
                >
                  <Descriptions.Item label="Base HP">
                    {base_hp}
                  </Descriptions.Item>
                  <Descriptions.Item label="Energy">{energy}</Descriptions.Item>
                  <Descriptions.Item label="XP Reward">{xp}</Descriptions.Item>
                  <Descriptions.Item label="Max Enemies">
                    {max_enemy}
                  </Descriptions.Item>
                  <Descriptions.Item label="Length">{length}</Descriptions.Item>
                </Descriptions>
              </Row>
              <Row style={{ padding: "16px 0 0px 0" }}>
                <StageDropsTable
                  drops={drops}
                  // viewportHeight={this.state.viewportHeight}
                />
              </Row>
              <Row style={{ padding: "16px 0 0px 0" }}>
                <StageEnemiesTable
                  enemies={enemies}
                  difficulties={difficulties}
                  // viewportHeight={this.state.viewportHeight}
                />
              </Row>
              <Row style={{ padding: "16px 0 0px 0" }}>
                <StageEnemiesCollapse enemies={enemies} />
              </Row>
            </div>
          </Content>
        </Layout>
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="9454688502"
        ></HorizontalAdPopup> */}
      </div>
    );
  }
}

export default SingleStage;

SingleStage.propTypes = {
  applyViewportChange: PropTypes.number,
};

SingleStage.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components-kr/content/SingleStage.js